// extracted by mini-css-extract-plugin
export default {"root":"RightAligned_root__Lfia9","button":"RightAligned_button__EvIND"};